var exports = {
  "RZ": "editorContainer__P6F8w-",
  "UM": "copilotWriteButton__VdbGjd",
  "C1": "validationErrorFlash__5pGvrj",
};

module.exports = exports;
